import { motion, useReducedMotion } from 'framer-motion'
import { Section } from '@shared/Section'
import { GlassCard, GlassCardContent } from '@/components/ui/glass-card'
import { steps } from '@features/landing/content'
import { icons } from '@features/landing/icons'

export function HowItWorks() {
  const reduceMotion = useReducedMotion()

  return (
    <Section
      id="how-it-works"
      eyebrow="How it works"
      title="From a phone call to a campaign, without the research backlog"
      description="Four stages, fully automated. You choose what to ask and who to ask; VoxDiscover handles everything between the conversation and the decision."
    >
      <ol className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {steps.map((step, index) => {
          const Icon = icons[step.icon]
          return (
            <motion.li
              key={step.title}
              initial={reduceMotion ? false : { opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.5, delay: index * 0.08, ease: 'easeOut' }}
            >
              <GlassCard className="h-full">
                <GlassCardContent className="flex h-full flex-col gap-3 p-6">
                  <div className="flex items-center gap-3">
                    <span className="flex size-10 items-center justify-center rounded-xl bg-linear-to-br from-cyan-500/30 via-blue-500/30 to-purple-500/30">
                      <Icon className="size-5 text-blue-700 dark:text-blue-200" aria-hidden />
                    </span>
                    <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                      Step {index + 1}
                    </span>
                  </div>
                  <h3 className="text-lg font-semibold text-foreground">{step.title}</h3>
                  <p className="text-sm leading-relaxed text-muted-foreground">{step.body}</p>
                </GlassCardContent>
              </GlassCard>
            </motion.li>
          )
        })}
      </ol>
    </Section>
  )
}
